import appCONST from 'constants/app.constants';

export default function L10nService(
    $http,
    $log,
    localStorageService,
    $window,
) {
    'ngInject';

    const LOCALIZED_STORAGE_KEY = 'localized-texts';
    const translationsUrl = '/staticdata/GetAllLocalization';

    $window.Trans = getTextsList();

    function getTextsList() {
        return localStorageService.get(LOCALIZED_STORAGE_KEY) || {};
    }

    function getAllTranslations(lang) {
        return $http.apiGET(translationsUrl, {params: {lang}})
            .then(({data}) => data)
            .then(updateList);
    }

    function updateList(localizedData) {
        localStorageService.set(LOCALIZED_STORAGE_KEY, localizedData);
        $window.Trans = getTextsList();
    }

    function getLocalization(text) {
        const value = $window.Trans[text];
        if (!value) {
            return text;
        }
        return value || text;
    }

    function localize(text) {
        if (appCONST.disableLocalization) {
            return '';
        }

        if (!_.isString(text)) {
            $log.warn('Localization key is not string: ', text);
            return '';
        }

        return getLocalization(text);
    }

    return {
        updateList,
        getList: function() {
            return getTextsList();
        },

        saveAndReturnLocalizationText: function(text) {

            /**
             * Text itself is a key and a value of localization
             */
            const localizePatch = {};
            localizePatch[text] = text;

            this.updateList(localizePatch);

            $http.apiPOST('/staticdata/GetLocalization', angular.toJson([text]));

            return this.getLocalization(text);
        },

        localizationExist: function(text) {
            if (text.length > 250) {
                $log.warn('You should use a custom key instead of text itself,'
                    + 'because server has restriction for keys (250 symbols length)', text);
            }

            return getTextsList().hasOwnProperty(text);
        },
        getLocalization,
        localize,
        getAllTranslations,
    };
}



// WEBPACK FOOTER //
// ./src/app/services/l10nService.js